module.exports = __webpack_public_path__ + "img/invoice.c2064225.svg";